(function () {
    "use strict";

    /**
     * Defines a dummy controller to disable the loader
     * This is needed when a view does not use angularjs.
     * Examples: LoginChoose, ChangePassword, ...
     */
    angular.module("app").controller("LoadingIndicatorDummyController", LoadingIndicatorDummyController);

    LoadingIndicatorDummyController.$inject = ["loadingIndicatorService"];
    function LoadingIndicatorDummyController(loadingIndicatorService) {
        loadingIndicatorService.SetLoadingState(false);
    }
})();